import React, { useEffect } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { Form, Grid, Icon, Portal, Segment } from "semantic-ui-react";
import "./index.scss"
import { Button, SettingsFooter, Notification, STATUS_TYPES } from "dyl-components";
import { MathUtils } from "utils";
import useWindowWidth from "shared/SettingsFooter/useWindowWidth";
import useWidthListener from "shared/SettingsFooter/useWidthListener";
import { useDispatch, useSelector } from "react-redux";
import tcrActions from "actions/tcr"
const MAX_LENGTH = 160;

export default function TextingPreferences() {
  const { control, formState: { isDirty, isValid }, reset, handleSubmit } = useForm({
    defaultValues: {
      enableOptOut: true,
      message: "Reply STOP to Opt-Out.",
      confirmation:
        "You have successfully unsubscribed from %s alerts. No further messages will be sent. Reply START to opt back in.",
    },
    mode: "onChange",

  });
  const dispatch = useDispatch();
  const enableOptOut = useWatch({ control, name: "enableOptOut" });
  const windowWidth = useWindowWidth();
  const width = useWidthListener("settingsSidebar");
  const { brandOptOutStatus, isReadingBrandOptOutStatus, isUpdatingBrandOptOutStatus, brand, isReadingBrand } = useSelector((state) => state.tcr);
 
  const onSubmit = (data) => {
    dispatch(tcrActions.updateBrandOptOutStatus(brand?.brandId, {
      use_opt_out_message: data.enableOptOut,
    }))
    reset(data)
    Notification.alert('Successfully updated texting prefences!', STATUS_TYPES.SUCCESS, true);
  }

  useEffect(() => {
    dispatch(tcrActions.getBrand()).then((data) => {
      dispatch(tcrActions.getBrandOptOutStatus(data?.brandId))
    })
  }, [dispatch])

  useEffect(() => {
    if (brandOptOutStatus) {
      reset({
        enableOptOut: brandOptOutStatus.use_opt_out,
        message: brandOptOutStatus.opt_out_message,
        confirmation: brandOptOutStatus.opt_out_message_back
      })
    }
  }, [brandOptOutStatus, reset])
  return (
    <Segment basic loading={isReadingBrandOptOutStatus || isReadingBrand}>
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column width={6}>
              <Controller
                name="enableOptOut"
                control={control}
                render={({ field }) => (
                  <Form.Checkbox
                    toggle
                    label="Texting Opt-Out Message"
                    checked={field.value}
                    onChange={(_, data) => field.onChange(data.checked)}
                  />
                )}
              />

              <Controller
                name="message"
                control={control}
                render={({ field }) => (
                  <>
                    <Form.TextArea
                      {...field}
                      rows={2}
                      disabled={!enableOptOut}
                      readOnly
                    />
                    <div className="TextingPreferences_Info">
                      Character Count: {field.value?.length || 0}/{MAX_LENGTH}
                      <Icon name="info circle" color="primary" style={{ marginLeft: 6 }} />
                    </div>
                  </>
                )}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={6}>
              <Controller
                name="enableOptOut"
                control={control}
                render={({ field }) => (
                  <Form.Checkbox
                    toggle
                    label="Texting Opt-Out Confirmation"
                    checked
                    onChange={(_, data) => field.onChange(data.checked)}
                    disabled
                  />
                )}
              />

              <Controller
                name="confirmation"
                control={control}
                render={({ field }) => (
                  <>
                    <Form.TextArea
                      {...field}
                      rows={2}
                      disabled
                      readOnly
                    />
                    <div className="TextingPreferences_Info">
                      Character Count: {field.value?.length || 0}/{MAX_LENGTH}
                      <Icon name="info circle" color="primary" style={{ marginLeft: 6 }} />
                    </div>
                  </>
                )}
              />
            </Grid.Column>
          </Grid.Row>

        </Grid>
      </Form>
      <Portal open>
        <SettingsFooter
          style={{ width: MathUtils.calculatePercentage(windowWidth, windowWidth - width) }}
          rightOptions={[
            <Button onClick={() => {
            }} disabled={!isDirty} status={'cancel'} basic>Cancel</Button>,
            <Button loading={isUpdatingBrandOptOutStatus} disabled={!isDirty || !isValid || isUpdatingBrandOptOutStatus} onClick={() => {
              handleSubmit(onSubmit)()
            }} primary>Save</Button>
          ]}
        />
      </Portal>
    </Segment>
  );
}